
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/scope-builder",
      function () {
        return require("private-next-pages/admin/scope-builder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/scope-builder"])
      });
    }
  